import React from 'react';
import styles from '../stripes.module.scss';
import { FocusContext } from '@noriginmedia/norigin-spatial-navigation';

interface Props {
  focusKey: string;
  scrollRef: React.Ref<HTMLDivElement>;
  children: React.ReactNode;
}

const StripesContainer: React.FC<Props> = ({ focusKey, scrollRef, children }) => (
  <div className={styles['stripes']}>
    <FocusContext.Provider value={focusKey}>
      <div className={styles['stripes-container']} ref={scrollRef}>{children}</div>
    </FocusContext.Provider>
  </div>
);

export default StripesContainer;
